import React from 'react';
import Styles from '../BlogPostPreview/BlogPostPreview.module.less';
import { Link } from '../../router/Link';
import { generatePath } from 'react-router-dom';
import routes from '../../../pages/landingPage/routes';
import { Preview } from '../BlogPostPreview';

export type AludeNewsPostPreviewProps = {
    image: string;
    subject: string;
    slug: string;
};

export const AludeNewsPostPreview = ({
    slug,
    subject,
    image,
}: AludeNewsPostPreviewProps): JSX.Element => {
    return (
        <Link
            to={generatePath(routes.blog.news.post.path, { postSlug: slug })}
            className={Styles.container}>
            <Preview url={slug} title={subject} image={image} />
        </Link>
    );
};
